import { useMutation } from 'react-query'

import { APIError } from '../../../../utils'
import { sendAsEInvoiceViaFrenchPdp } from '../../query-api'

interface UseSendAsEInvoiceViaFrenchPdpOptions {
  onError?: (error?: APIError) => void
  onSuccess?: () => void
}

export const useSendAsEInvoiceViaFrenchPdpMutation = (props?: UseSendAsEInvoiceViaFrenchPdpOptions) => {
  const { onError, onSuccess } = props || {}
  const { mutate: send, isLoading, ...rest } = useMutation(sendAsEInvoiceViaFrenchPdp, { onSuccess, onError })

  return { send, isProcessing: isLoading, ...rest }
}
